import request from '@/utils/request'

/**
 * 获取奖品分页列表
 * @param data 
 * @returns 
 */
export const getDrawPrizePage = (data: any) => {
  return request({
    url: '/admin/drawPrize/page',
    method: 'get',
    params: data
  })
}

/**
 * 查询奖品详情
 * @param id 
 * @returns 
 */
export const queryDrawPrizeById = (id: any) => {
  return request({
    url: `/admin/drawPrize/${id}`,
    method: 'get'
  })
}

/**
 * 新增奖品
 * @param data 
 * @returns 
 */
export const addDrawPrize = (data: any) => {
  return request({
    url: '/admin/drawPrize',
    method: 'post',
    data
  })
}

/**
 * 修改奖品
 * @param data 
 * @returns 
 */
export const editDrawPrize = (data: any) => {
  return request({
    url: '/admin/drawPrize',
    method: 'put',
    data
  })
}

/**
 * 删除奖品
 * @param ids 
 * @returns 
 */
export const deleteDrawPrize = (ids: any) => {
  return request({
    url: '/admin/drawPrize',
    method: 'delete',
    params: { ids }
  })
}

/**
 * 获取所有奖品列表
 * @returns 
 */
export const listDrawPrize = () => {
  return request({
    url: '/admin/drawPrize/list',
    method: 'get'
  })
}